
import axios from 'axios'; 

export function getAddressInformations(postalCode){
    return new Promise(async (resolve, reject) => {
        try{
            const res = await axios.get(`https://viacep.com.br/ws/${postalCode}/json`);

            let data = null;

            if(res.data && !res.data.erro){
                const d = res.data;

                data = {
                    cep: d.cep,
                    city: d.localidade,
                    state: d.uf,
                    street: d.logradouro,
                    district: d.bairro ?? 'Sem informações'
                }
            }

            resolve(data);

        } catch (e) {
            reject(e);
        }
    })
}